import React from 'react';
import { returnBrandingInformation } from '../../functions/utils';

class BillboardFixed extends React.Component {
	componentDidMount() {
		this.loadImage(this.props.billboardAsset);
	}

	componentDidUpdate(prevProps) {
		
		if ((!prevProps.billboardAsset && this.props.billboardAsset)
			|| (prevProps.billboardAsset
			&& this.props.billboardAsset
			&& prevProps.billboardAsset._id !== this.props.billboardAsset._id)
		) {
			this.loadImage(this.props.billboardAsset);
		}
	}

	loadImage(billboardAsset) {
		const htmlCollection = document.getElementsByClassName('billboard-fixed-image');
		const billboardImage = htmlCollection && htmlCollection[0];
		const url = billboardAsset && billboardAsset.images && billboardAsset.images.background;

		if (billboardImage) {
			billboardImage.classList.add("loading");
			
			setTimeout(() => { billboardImage.src = url; }, 600);
			
			billboardImage.onload = () => {
				billboardImage.classList.remove("loading");
			};
		}
	}

	render() {
		const { billboardAsset, rowInformation } = this.props;
		const assetTitleImg = billboardAsset && billboardAsset.images && billboardAsset.images.title;
		const assetGenres = billboardAsset && billboardAsset.content && billboardAsset.content.genres;
		const assetDescription = billboardAsset && billboardAsset.content && billboardAsset.content.description;
		const brandingInfo = returnBrandingInformation(billboardAsset, rowInformation);

		return (
			<div id="PeacockFixedBillboard" className="billboard-fixed bg-image">
				<div className="billboard-gradient"></div>

				<div className='billboard-fixed-image-wrapper'>
					{billboardAsset && <img className="billboard-fixed-image"/>}
				</div>

				<div className='billboard-fixed-asset-details'>
					{/* this the image title card */}
					{assetTitleImg ?
						<div className='billboard-title-img'><img src={assetTitleImg} /></div>
						:
						<div className='billboard-fixed-title'>{billboardAsset.name}</div>
					}
					{assetGenres && <div className='billboard-genres'>{assetGenres.join(" ")}</div>}
					{assetDescription && <div className={`billboard-description ${brandingInfo ? "mb-15" : ""}`}>{assetDescription}</div>}
					{brandingInfo &&
						<div className='billboard-curator-branding'>
							<p className="m-0 mr-5">Presented by</p>
							<img src={brandingInfo.branding} />
						</div>
					}
				</div>
			</div>
		);
	}
}

// export default connect(mapStateToProps, mapDispatchToProps)(BillboardFixed);
export default BillboardFixed;


// WEBPACK FOOTER //
// ./src/components/svod/BillboardFixed.js